"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionPlanId = void 0;
var SubscriptionPlans_1 = require("../constants/SubscriptionPlans");
var getSubscriptionPlanId = function (subscriptionPlanName) {
    var subscriptionPlan = SubscriptionPlans_1.SUBSCRIPTION_PLANS.find(function (subscription) { return subscription.name === subscriptionPlanName; });
    return subscriptionPlan === null || subscriptionPlan === void 0 ? void 0 : subscriptionPlan.id;
};
exports.getSubscriptionPlanId = getSubscriptionPlanId;
